export default class Constants {
    static SESSION_LOGIN = 'login';
    static CURRENT_COUNTRY_CD = 'currentCountryCd';
    static EVENT_UPDATE_CART = 'updateCart';
    static EVENT_KEEP_ALIVE_RESET = 'loginStatusChange';
    static APP_VERSION = 'appVersion';
    static NEW_CUSTOMER = 'newCustomer';
    static RECENT_PRODUCTS = 'recentProducts';
    static RECENT_PRODUCTS_INFO = 'recentProductsInfo';
    static AGREE_TERMS = 'agreeTerms';
    static AUTO_SAVED_REVIEW = 'savedReview';
    static AUTO_SAVED_FEED = 'savedFeed';
    static AUTO_SAVED_TALK = 'savedTalk';
    static MAIN_NOTICE_HIDDEN_TODAY = 'mainNoticeHiddenToday';
    static APP_INSTALL_HIDDEN_TODAY = 'appInstallHiddenToday';
    static MEM_GRADE_FIRST_PURCHASE = '00';
    static MAIN_FLOATING_BANNERS_CLOSED = 'mainFloatingBannersClosed';
    static NOTIFICATION_SEQ1 = 'notificationSeq1';
    static NOTIFICATION_SEQ2 = 'notificationSeq2';
    static SAVED_FCM_USER_TOKEN = 'savedFcmUserToken';    
    static ORDER_PAYMENT_CD = 'orderPaymentCd';
    static SEARCH_HISTORIES = 'searchStorage';
    static MENU_POSITION_TOP = 51;
    static MEMBER_INFO = 'memberInfo';
    static NOTIFICATION_POINT_HIDDEN_TODAY = 'notificationPointHiddenToday';
    static STORED_URL_FOR_REDIRECT = "storeUrlForRedirect";

    // GTag 커스텀 이벤트
    static CUSTOM_PROMOTION_VIEW = 'custom_promotion_view'; // 프로모션 페이지 진입
    static CUSTOM_ORDER_CLAIM = 'custom_order_claim';   // 주문 취소(반품) 요청

    static REGEXP_EMAIL = /^[0-9a-zA-Z]([-_.]*?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/; // 이메일
    static REGEXP_ID_CARD = /[0-9]{18}/g;                           // 아이디카드(샤오미)
    static REGEXP_BIRTHDAY = /^(19[0-9][0-9]|20\d{2})(0[0-9]|1[0-2])(0[1-9]|[1-2][0-9]|3[0-1])$/;   // 생년월일
    static REGEXP_PHONENUMBER = /^[0-9]\d{10}$/;                    // 휴대폰번호
    static REGEXP_PHONENUMBER_NOT_ALLOW_STRING = /[^0-9]/g;         // 휴대폰 비허용 문자열
    static REGEXP_ID = /^[a-zA-Z0-9]{5,15}$/;                       // 아이디

    static EXTERNAL_PARAM_REF_ID = 'refId';
    static EXTERNAL_PARAM_REF_MEM_CD = 'refMemCd';
    
}